/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/login-domains/${encodeURIComponent(request.path['domain'] as any)}`,
    // @ts-ignore for sm-axios
    urlTemplate: '/login-domains/{domain}',
    method: 'GET',
    params: request.query,
  })
}

/**
 * details of a login domain
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  path: {
    domain: string
  }
  query?: {
    themeCode?: string
  }
}

export interface Response {
  domain: string
  theme: {
    code: string
    name?: string
    images: {
      logo?: string
      favicon?: string
      [k: string]: any
    }
    links: {
      loginHelpUrl?: string
      contactSupportUrl?: string
      [k: string]: any
    }
    colours: {
      primaryBackground?: string
      primaryForeground?: string
      secondaryBackground?: string
      secondaryForeground?: string
      tertiaryBackground?: string
      tertiaryForeground?: string
      [k: string]: any
    }
    [k: string]: any
  }
  tenant?: {
    code: string
    aliasCode?: string
    loginClientId: string
    enablePasskey: boolean
    loginDomain: string
    [k: string]: any
  }
  [k: string]: any
}

